import axios from 'axios';
import { present } from '@/shared/utils/typescript';
import { formatFluidData, parseFluid, parseFluids, parseReplenishedFluids } from '../converters/fluidConverters';
import { DossierId } from '../models/AbstractDossier';
import Fluid, { FluidData, FluidId, FluidTypeId } from '../models/Fluid';

export default class FluidClient {
  static async loadReplenished(dossierId: DossierId): Promise<Array<Fluid>> {
    const response = await axios.get(`/api/mobopro/v1/dossierfluids/${dossierId}/replenished`);
    return parseReplenishedFluids(response.data);
  }

  static async loadAll(dossierId: DossierId): Promise<Array<Fluid>> {
    const response = await axios.get(`/api/mobopro/v1/dossierfluids/${dossierId}`);
    return parseFluids(response.data.fluids);
  }

  static async create(data: FluidData, typeId: FluidTypeId, dossierId: DossierId): Promise<Fluid> {
    const response = await axios.post(`/api/mobopro/v1/dossierfluids?dossierId=${dossierId}&fluidid=${typeId}`, formatFluidData(data));
    return present(parseFluid(response.data));
  }

  static async update(id: FluidId, data: FluidData): Promise<Fluid> {
    const response = await axios.put(`/api/mobopro/v1/dossierfluids/${id}`, formatFluidData(data));
    return present(parseFluid(response.data));
  }

  static async remove(id: FluidId): Promise<void> {
    await axios.delete(`/api/mobopro/v1/dossierfluids/${id}`);
  }
}
